<template>
  <div style="text-align: center;">
    <b-form-group class="mt-2">
      <b-row>
        <b-col>
          <b-form-radio
            button
            button-variant="light"
            v-model="orderoptions.ordertype"
            name="how-order"
            value='2'
            class="py-2 mx-1 pnd-buttons"
            @input="emitOrderOptions()">
              &#127939; TO-GO
          </b-form-radio>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-radio
            button
            v-if="selectedLocation.allow_delivery"
            button-variant="light"
            v-model="orderoptions.ordertype"
            name="how-order"
            value='1'
            class="py-2 mx-2 pnd-buttons"
            @input="initMQPlaceSearch()">
              &#128757; DELIVERY
          </b-form-radio>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-radio
            button
            v-if="selectedLocation.allow_dinein"
            button-variant="light"
            v-model="orderoptions.ordertype"
            name="how-order"
            value='4'
            class="py-2 mx-1 pnd-buttons"
            @input="emitOrderOptions()">
            &#127860; DINE-IN
          </b-form-radio>
        </b-col>
      </b-row>
    </b-form-group>

    <div v-if="orderoptions.ordertype=='1'">
      <b-row>
        <b-col>&#128757; <span class="px-sm-2"><b>Delivery Address:</b> </span></b-col>
      </b-row>
      <b-row>
        <b-col><b-form-input v-model="orderoptions.cust_addr" type="search" id="cust-addr-search" placeholder="Enter address"></b-form-input></b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col><p class="delinfo">Delivery fee: {{ selectedLocation.delivery_fee | toCurrency }}</p></b-col>
      </b-row>
      <b-row>
        <b-col><p class="delinfo">Minimum order: {{ selectedLocation.delivery_minimum | toCurrency }}</p></b-col>
      </b-row>
    </div>
    <div v-else-if="orderoptions.ordertype=='4'">
      <b-row>
        <b-col>&#127860; <span class="px-2"><b>Table number:</b> </span></b-col>
      </b-row>
      <!-- insert blank row to stop delivery address overwrite other options -->
      <b-row></b-row>
      <b-row>
        <b-col><b-form-input v-model="orderoptions.table" id="table" type="number" placeholder="Enter your table number" @input="emitOrderOptions()"></b-form-input></b-col>
      </b-row>
    </div>
    <div v-if="orderoptions.ordertype=='2'">
      <b-row>
        <b-col>&#127939; <span class="px-2"><b>Pickup from:</b> </span></b-col>
      </b-row>
      <!-- insert blank row to stop delivery address overwrite other options -->
      <b-row></b-row>
      <b-row>
        <b-col>{{ location_mailing_address }}</b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'PickupDelivery',
  props: ['selectedLocation', 'selectedMenuDate'],
  data () {
    return {
      orderoptions: {
        cust_addr: '',
        address_confirmed: false,
        ordertype: '2',
        table: 0,
        deldistance: 0
      },
      delAddrLatLong: {},
    }
  },

  computed: {
    location_mailing_address: function() {
      if (Object.keys(this.selectedLocation).length > 0) {
        const ad = this.selectedLocation.location_addresses.filter(addr => addr.address_type_id==1);
        return ad[0].address;
      } else {
        return '';
      }
    },

    // displayOrderChoices: function() {
    //   // if either allow delivery and allow dine in are true and today is the selected Menu Date - TRUE (display pickupDelivery choices)
    //   if ((this.selectedLocation.allow_delivery || this.selectedLocation.allow_dinein) && this.selectedMenuDate==moment().format('YYYY-MM-DD')) {
    //     return true;
    //   } else {
    //     // set order type back to default
    //     this.setOrderTypeToDefault();
    //     return false;
    //   }
    // },

    // Calculate distance in miles from Location Lat/Long to delivery address - Thanks Google Cloud
    haversine_distance: function() {
      const mk1 = {
        "lat": this.selectedLocation.lat,
        "lng": this.selectedLocation.long
      }
      const mk2 = this.delAddrLatLong

      var R = 3958.8; // Radius of the Earth in miles
      // var rlat1 = mk1.position.lat() * (Math.PI/180); // Convert degrees to radians
      var rlat1 = mk1.lat * (Math.PI/180); // Convert degrees to radians
      // var rlat2 = mk2.position.lat() * (Math.PI/180); // Convert degrees to radians
      var rlat2 = mk2.lat * (Math.PI/180); // Convert degrees to radians
      var difflat = rlat2-rlat1; // Radian difference (latitudes)
      var difflon = (mk2.lng-mk1.lng) * (Math.PI/180); // Radian difference (longitudes)

      var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
      return d;
    }

  },

  methods: {
    emitOrderOptions() {
      this.$emit('emit-order-options', this.orderoptions);
    },

    setOrderTypeToDefault() {
      this.orderoptions.ordertype = 2;
    },

    async initMQPlaceSearch() {
      this.emitOrderOptions();
      if (this.orderoptions.ordertype=='1') {
        await (document.querySelector("#cust-addr-search") != null)
        let ps = window.placeSearch({
          key: process.env.VUE_APP_MAPQUEST_KEY,
          container: document.querySelector("#cust-addr-search"),
          collection: [
            'address',
          ],
          templates: {
            suggestion: function(result) {
              return `<span class="mq-no-style-result-icon addr-results">${result.searchAheadResult.displayString}</span>`;
            },
          }
        });

        ps.on('change', (e) => {
          this.orderoptions.address_confirmed=true;
          this.delAddrLatLong = e.result.latlng;
          this.orderoptions.deldistance = this.haversine_distance
          this.emitOrderOptions();
          // this.$emit('emit-delivery-distance', this.haversine_distance);
        });
      }
    },

  },

}
</script>
<style>

.mq-place-search {
  z-index: 1000;
  text-align:left;
  font-size: small;
  /* overflow-wrap: normal; */
}

@media (max-width: 767px) {
  .mq-result {
    padding-left: 2px !important;
    margin-left: 0 !important;
    word-wrap:break-word !important;
    /* max-width:20ch !important; */
    overflow-x: visible !important;
    line-height: 1.5 !important
  }

}

@media (min-width: 768px) {
  .mq-place-search {
    font-size: medium;
  }

}

</style>
